import React, { useRef } from 'react'
import './timeline.css'
import TimelineEntry from './TimelineEntry'
import { timelineEntries } from '../../data/TimelineEntries'
import useIntersection from '../../hooks/useIntersection'


function Timeline() {
  const ref = useRef()
  useIntersection(ref)

  return (
    <div className="timeline" id="timeline" ref={ref}>
      <div className="timeline-title">
        <h1>timeline.</h1>
      </div>
      <h3>my journey so far...</h3>
      <div className="timeline-timeline">
        <div className="timeline-line"/>
        <div>
          {timelineEntries.map((entry, i) => 
             <TimelineEntry key={i} {...entry}/>
          )}
        </div>
      </div>
    </div>
  )
}

export default Timeline
